import { render, staticRenderFns } from "./NoSideBar.vue?vue&type=template&id=343f899e&"
import script from "./NoSideBar.vue?vue&type=script&lang=ts&"
export * from "./NoSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports